import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorStore = defineStore('error', () => {
  const errorMessage = ref<string | null>(null)

  const setError = (message: string) => {
    errorMessage.value = message
  }

  const clearError = () => {
    errorMessage.value = null
  }

  return {
    errorMessage,
    setError,
    clearError,
  }
})
